"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiCalendar = function IconUiCalendar(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M44 6.375h-8V4h-2v2.375H14V4h-2v2.375H4v35.25h40zm-32 2V10h2V8.375h20V10h2V8.375h6V13H6V8.375zm-6 31.25V15h36v24.625z"
  }), _react.default.createElement("circle", {
    cx: 18,
    cy: 20,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 30,
    cy: 20,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 36,
    cy: 20,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 18,
    cy: 26.846,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 24,
    cy: 26.846,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 30,
    cy: 26.846,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 36,
    cy: 26.846,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 18,
    cy: 33.846,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 24,
    cy: 33.846,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 30,
    cy: 33.846,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 36,
    cy: 33.846,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 12,
    cy: 26.846,
    r: 1
  }), _react.default.createElement("circle", {
    cx: 12,
    cy: 33.846,
    r: 1
  }));
};

IconUiCalendar.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiCalendar;
exports.default = _default;